"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";
import StackedContentComponent from "../ui/StackedContentComponent";

const ContentSectionComponent: React.FC<
  SectionProps<{
    content: any;
    align: {
      vertical: string;
      horizontal: string;
    };
  }> & {
    recaptchaSiteKey: string;
  }
> = ({ cmsSection, index, cmsData, app, recaptchaSiteKey }) => {
  const getSizeClassName = () => {
    switch (cmsSection.ui?.contentWidth) {
      case "lg":
        return "max-w-screen-lg";
      case "xl":
        return "max-w-screen-xl";
      case "2xl":
        return "max-w-screen-2xl";
      case "4xl":
        return "max-w-screen-4xl";
      case "full":
        return "w-full";
      default:
        return "max-w-screen-xl";
    }
  };

  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "4xl",
        padding: "none",
      })}
      revealsByElement
    >
      <div
        className={`flex flex-1 h-full  items-${cmsSection.specifics.align?.vertical ?? "center"} justify-${cmsSection.specifics.align?.horizontal ?? "center"} section-${index}`}
      >
        <div className={`${getSizeClassName()} `}>
          <StackedContentComponent
            cmsData={cmsData}
            config={cmsSection.specifics.content}
            list="content"
            index={index}
            cmsSection={cmsSection}
            app={app}
            recaptchaSiteKey={recaptchaSiteKey}
          />
        </div>
      </div>
    </SectionLayout>
  );
};

export default ContentSectionComponent;
